<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}通知公告
        </div>
        <div class="fr">
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  标题
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.title" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  通知公告类型
                </th>
                <td>
                  <dict-select :dict-item-name.sync="formData.bulletinTypeName"
                               :dict-item-id.sync="formData.bulletinTypeId"
                               dict-type="通知公告类型"
                  />
<!--                  <el-select v-model="formData.bulletinTypeId" placeholder="">-->
<!--                    <el-option v-for="item in bulletinTypeOption" :key="item.value" :label="item.label"-->
<!--                               :value="item.value"/>-->
<!--                  </el-select>-->
                </td>
                <th>
                  是否置顶
                </th>
                <td>
                  <el-select v-model="formData.isTop">
                    <el-option label="否" :value="0"/>
                    <el-option label="是" :value="1"/>
                  </el-select>
                </td>
                <th>
                  <em class="f-red">*</em>
                  是否发布
                </th>
                <td>
                  <el-select v-model="formData.isPublic">
                    <el-option label="否" :value=0></el-option>
                    <el-option label="是" :value=1></el-option>
                  </el-select>
                </td>
              </tr>
              <tr>


              </tr>
              <tr>
                <th>创建人</th>
                <td>{{ formData.createBy }}</td>
                <th>创建时间</th>
                <td>{{ formData.createTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="d-item" style="height: 60vh;">
            <el-row :gutter="30">
              <el-col :span="6">
                <div class="title first">
                  <b>附件信息</b>
                  <el-upload style="display:flex; margin-top: -6px; float: right"
                             class="upload-demo"
                             ref="upload"
                             :action="api.uploadFileUrl"
                             accept=".docx,.doc,.txt,.pdf,.xlsx"
                             v-if="fileList.length < 5"
                             :show-file-list="false"
                             :on-success="(res,file, fileList) => {handleFileSuccess(res,file, fileList)}"
                             :headers="headers"
                             :auto-upload="true"
                  >
                    <el-button type="primary" class="button-sty btn_zdy2">
                      <i class="el-icon-plus"></i>
                      附件
                    </el-button>
                  </el-upload>
                </div>
                <div class="current-info">
                  <vxe-table ref="filterTable"
                             class="table_item pic_item mytable-scrollbar"
                             :column-config="{ resizable: true }"
                             style="width: 100%;"
                             :stripe="true"
                             :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{height: 30,isHover: true,padding: 0,}"
                             :row-style="{ fontSize: '12px',  }"
                             show-overflow
                             :data="fileList"
                  >
                    <vxe-column field="name" title="附件名称" width="">
                      <template #default="{row}">
                        <a :href="row.url" :download="row.name">{{row.name}}</a>
                      </template>
                    </vxe-column>
                    <vxe-column title="操作" width="60">
                      <template #default="{row}">
                        <div @click="deleteFile(row)">
                          <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                      popper-class="tooltip-skin">
                            <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                          </el-tooltip>
                        </div>
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>
              </el-col>
              <el-col :span="18">
                <div class="title first">
                  <b>内容</b>
                </div>
                <div>
                  <quill-editor class="editor"
                                ref="myTextEditor"
                                v-model="formData.content"
                                :options="editorOption"
                                @blur="onEditorBlur($event)"
                                @focus="onEditorFocus($event)"
                                @ready="onEditorReady($event)"
                                @change="onEditorChange($event)">
                  </quill-editor>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

      </div>
    </el-form>
    <productCategoryDialog v-if="showProductCategoryDialog" :visiable.sync="showProductCategoryDialog" multi="false"
                           @confirm="confirmCategory"/>
  </div>
</template>
<script>
import Tinymce from '@/components/Tinymce';
import request from "@/router/axios";
import api from "@/api/projectApi";
import DictSelect from "@/components/formItem/dictSelect.vue";
import {editPageMixins} from "@/mixins/tabChang";
import store from "@/store";
// toolbar标题
const titleConfig = [
  {Choice: '.ql-insertMetric', title: '跳转配置'},
  {Choice: '.ql-bold', title: '加粗'},
  {Choice: '.ql-italic', title: '斜体'},
  {Choice: '.ql-underline', title: '下划线'},
  {Choice: '.ql-header', title: '段落格式'},
  {Choice: '.ql-strike', title: '删除线'},
  {Choice: '.ql-blockquote', title: '块引用'},
  {Choice: '.ql-code', title: '插入代码'},
  {Choice: '.ql-code-block', title: '插入代码段'},
  {Choice: '.ql-font', title: '字体'},
  {Choice: '.ql-size', title: '字体大小'},
  {Choice: '.ql-list[value="ordered"]', title: '编号列表'},
  {Choice: '.ql-list[value="bullet"]', title: '项目列表'},
  {Choice: '.ql-direction', title: '文本方向'},
  {Choice: '.ql-header[value="1"]', title: 'h1'},
  {Choice: '.ql-header[value="2"]', title: 'h2'},
  {Choice: '.ql-align', title: '对齐方式'},
  {Choice: '.ql-color', title: '字体颜色'},
  {Choice: '.ql-background', title: '背景颜色'},
  {Choice: '.ql-image', title: '图像'},
  {Choice: '.ql-video', title: '视频'},
  {Choice: '.ql-link', title: '添加链接'},
  {Choice: '.ql-formula', title: '插入公式'},
  {Choice: '.ql-clean', title: '清除字体格式'},
  {Choice: '.ql-script[value="sub"]', title: '下标'},
  {Choice: '.ql-script[value="super"]', title: '上标'},
  {Choice: '.ql-indent[value="-1"]', title: '向左缩进'},
  {Choice: '.ql-indent[value="+1"]', title: '向右缩进'},
  {Choice: '.ql-header .ql-picker-label', title: '标题大小'},
  {Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一'},
  {Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二'},
  {Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三'},
  {Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四'},
  {Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五'},
  {Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六'},
  {Choice: '.ql-header .ql-picker-item:last-child', title: '标准'},
  {Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号'},
  {Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号'},
  {Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号'},
  {Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准'},
  {Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐'},
  {Choice: '.ql-align .ql-picker-item[data-value="center"]', title: '居中对齐'},
  {Choice: '.ql-align .ql-picker-item[data-value="right"]', title: '居右对齐'},
  {Choice: '.ql-align .ql-picker-item[data-value="justify"]', title: '两端对齐'}
]
export default {
  mixins: [editPageMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    DictSelect,
    Tinymce,
  },
  data() {
    return {
      fileList: [],
      formData: {
        bulletinTypeId: null,  // 通知公告类型ID，关联脚手架数据字典项目表sys_dict_item.id
        bulletinTypeName: null,
        title: null,  // 标题
        isTop: 0,  // 是否置顶:0否1是
        isPublic: 0,  // 是否发布:0否1是
        content: null,  // 内容;注意为富文本
        file1: null,
        file2: null,
        file3: null,
        file4: null,
        file5: null,
      },
      // bulletinTypeOption: [],



      img_b: "",
      upload_btn: false, // 是否隐藏上传图片按钮
      radio: '1',
      showEdit: false,
      valuetype: 'model',
      textarea: '',
      //  value1: true,
      value2: false,
      value3: true,
      activeName: 'first',
      dialog: {
        one: false,
      },
      lan: 'zh_CN',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
      intValueSplit: '',
      // 基本信息
      service: {
        pic: '',
      },

      showProductCategoryDialog: false,
      content: null,
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
            ["blockquote", "code-block"], // 引用  代码块
            [{header: 1}, {header: 2}], // 1、2 级标题
            [{list: "ordered"}, {list: "bullet"}], // 有序、无序列表
            [{script: "sub"}, {script: "super"}], // 上标/下标
            [{indent: "-1"}, {indent: "+1"}], // 缩进
            // [{'direction': 'rtl'}],                         // 文本方向
            [{size: ["small", false, "large", "huge"]}], // 字体大小
            [{header: [1, 2, 3, 4, 5, 6, false]}], // 标题
            [{color: []}, {background: []}], // 字体颜色、字体背景颜色
            [{font: []}], // 字体种类
            [{align: []}], // 对齐方式
            ["clean"], // 清除文本格式
            ["link", "image", "video"] // 链接、图片、视频
          ], //工具菜单栏配置
        },
        placeholder: '请在这里添加产品描述', //提示
        readyOnly: false, //是否只读
        theme: 'snow', //主题 snow/bubble
      }
    };
  },
  computed: {
    api() {
      return api
    },
    // enabled: {}
    editor() {
      return this.$refs.myTextEditor.quillEditor;
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    },
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    // console.log(this.tenant,"tenant的值");
  },
  mounted() {
    this.initTitle();
    this.getData();
    // this.loadDictData()
  },
  methods: {
    handleFileSuccess(res, file, fileList) {
      console.log('--------------------------')
      this.$mask.open()

      let url = res.data.url
      let fileName = file.name
      console.log(url, "url")
      console.log(fileName, "name")
      this.fileList.push({
        name: fileName,
        url: url
      })
      this.$mask.close()

    },

    deleteFile(row) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        console.log(row, 'delete')
        this.fileList = this.fileList.filter(item => item.url !== row.url)
      })
    },





    // // 加载数据字典中通知公告类型
    // loadDictData() {
    //   loadDictData(dictType.bulletinType).then(res => {
    //     this.bulletinTypeOption = []
    //     res.data.data.forEach(item => {
    //       this.bulletinTypeOption.push({
    //         label: item.label,
    //         value: item.id
    //       })
    //     })
    //   })
    // },



    initTitle() {
      document.getElementsByClassName('ql-editor')[0].dataset.placeholder = ''
      for (let item of titleConfig) {
        let tip = document.querySelector('.quill-editor ' + item.Choice)
        if (!tip) continue
        tip.setAttribute('title', item.title)
      }
    },
    // 失去焦点
    onEditorBlur(editor) {
    },
    // 获得焦点
    onEditorFocus(editor) {
    },
    // 开始
    onEditorReady(editor) {
    },
    // 值发生变化
    onEditorChange(editor) {
      this.content = editor.html;
      console.log(editor);
    },


    confirmSaleConfig(rows) {
      if (rows.length > 0) {
        const $grid = this.$refs.configGrid;
        const tableData3 = $grid.getTableData().fullData;
        const map = {};
        tableData.forEach(function (item) {
          map[item.configId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            configId: row.id,
            configName: row.configName
          };
          if (index == 0 && tableData3.length == 0) {
            item.defaults = true;
          }
          if (!map[item.configId]) {
            items.push(item);
          }
        });
        this.product.saleProductConfigDTOs = this.product.saleProductConfigDTOs.concat(items);
      }
    },
    // 上传成功


    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        request({
          url: api.basBulletin.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(res => {
          this.formData = res.data.data
          let data = this.formData

          this.fileList = []
          if (data.file1) {
            this.fileList.push({url: data.file1, name: data.file1Name})
          }
          if (data.file2) {
            this.fileList.push({url: data.file2, name: data.file2Name})
          }
          if (data.file3) {
            this.fileList.push({url: data.file3, name: data.file3Name})
          }
          if (data.file4) {
            this.fileList.push({url: data.file4, name: data.file4Name})
          }
          if (data.file5) {
            this.fileList.push({url: data.file5, name: data.file5Name})
          }
        })
      } else {
        // this.enabled = true;
      }
    },
    saveData() {
      let rules = {
        title: [{prop: '标题', required: true, maxlength: 50, type: 'string'}],
        bulletinTypeId: [{prop: '通知公告类型', required: true}],
        isPublic: [{prop: '是否发布', required: true}]
      }
      this.$validate(this.formData, rules).then(() => {
        this.$baseConfirm('您确定要保存吗？').then(() => {
          if (this.fileList) {
            this.formData.file1 = null
            this.formData.file1Name = null
            this.formData.file2 = null
            this.formData.file2Name = null
            this.formData.file3 = null
            this.formData.file3Name = null
            this.formData.file4 = null
            this.formData.file4Name = null
            this.formData.file5 = null
            this.formData.file5Name = null

            let length = this.fileList.length
            if (length >= 1) {
              this.formData.file1 = this.fileList[0].url
              this.formData.file1Name = this.fileList[0].name
            }
            if (length >= 2) {
              this.formData.file2 = this.fileList[1].url
              this.formData.file2Name = this.fileList[1].name
            }
            if (length >= 3) {
              this.formData.file3 = this.fileList[2].url
              this.formData.file3Name = this.fileList[2].name
            }
            if (length >= 4) {
              this.formData.file4 = this.fileList[3].url
              this.formData.file4Name = this.fileList[3].name
            }
            if (length >= 5) {
              this.formData.file5 = this.fileList[4].url
              this.formData.file5Name = this.fileList[4].name
            }
          }

          this.$mask.open()
          var url = (this.isEdit ? api.basBulletin.updateDataUrl : api.basBulletin.addDataUrl);
          this.$http({
            url: url,
            method: `post`,
            data: this.formData,
            isLoading: true,
          }).then(res => {
            this.$message.success("保存成功！")
            this.goBackIndex()
            this.$mask.close()
          }).catch(e => {
            console.error(e)
            this.$message.error("保存失败！")
            this.$mask.close()
          });
        });
      })
    },

  },
};

</script>
<style lang="scss" scoped>

.editor {
  line-height: normal !important;
  height: 43vh;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
  content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: '保存';
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode=video]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  content: '等宽字体';
}

.btn_zdy2{
  margin-top: 5px;
}
</style>
